module.exports = __webpack_public_path__ + "static/img/xingkongbei.4b75e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/man/product/xingkongbei.jpg
// module id = KaBS
// module chunks = 0